import { useHistory } from 'react-router';

const useNavigateTo = () => {
  const history = useHistory();

  const navigateTo = (location) => history.push(location);

  return Object.freeze({
    navigateTo
  });
};

export { useNavigateTo };
